module.exports = __webpack_public_path__ + "img/海量模版.01d7e651.gif";